function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LineSegment from '../../geom/LineSegment';
var MonotoneChainOverlapAction = /*#__PURE__*/function () {
  function MonotoneChainOverlapAction() {
    _classCallCheck(this, MonotoneChainOverlapAction);
    MonotoneChainOverlapAction.constructor_.apply(this, arguments);
  }
  return _createClass(MonotoneChainOverlapAction, [{
    key: "overlap",
    value: function overlap() {
      if (arguments.length === 2) {
        var seg1 = arguments[0];
        var seg2 = arguments[1];
      } else if (arguments.length === 4) {
        var mc1 = arguments[0];
        var start1 = arguments[1];
        var mc2 = arguments[2];
        var start2 = arguments[3];
        mc1.getLineSegment(start1, this._overlapSeg1);
        mc2.getLineSegment(start2, this._overlapSeg2);
        this.overlap(this._overlapSeg1, this._overlapSeg2);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MonotoneChainOverlapAction;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { MonotoneChainOverlapAction as default };
MonotoneChainOverlapAction.constructor_ = function () {
  this._overlapSeg1 = new LineSegment();
  this._overlapSeg2 = new LineSegment();
};